// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__14gk7","text":"classes_text__1Ww5A","logo-container":"classes_logo-container__2r5QL","logo":"classes_logo__3A0Lg"};